// extracted by mini-css-extract-plugin
export default {"not-found":"notFound_not-found__04CKR","not-found__icon":"notFound_not-found__icon__s3Lmd","not-found__text":"notFound_not-found__text__+2jmF"};